module.exports = __webpack_public_path__ + "img/ico_share_copy.20b2b5d9.png";